import React, { useState, useRef } from "react";
import "react-html5-camera-photo/build/css/index.css";
import Camera from "react-html5-camera-photo";
import {
  Cropper,
  RectangleStencil
} from "react-advanced-cropper";
import "react-advanced-cropper/dist/style.css";

const CameraWithCrop = ({ onImageCapture }) => {
  const cropperRef = useRef(null);

  const [isCameraOpen, setIsCameraOpen] = useState(true);
  const [imageData, setImageData] = useState(null);
  const [permissionError, setPermissionError] = useState(false);

  // 📸 Capture image
  const handleTakePhoto = (dataUri) => {
    setImageData(dataUri);      // base64 image
    setIsCameraOpen(false);     // close camera
  };

  // ✅ Confirm crop
  const handleConfirmCrop = async () => {
    const cropper = cropperRef.current;
    if (!cropper) return;

    const canvas = cropper.getCanvas();
    if (!canvas) return;

    canvas.toBlob((blob) => {
      const file = new File([blob], "captured-image.png", {
        type: "image/png",
      });
      onImageCapture(file);     // 🔥 SEND FINAL FILE
      resetState();
    }, "image/png");
  };

  const handleRetake = () => {
    resetState();
  };

  const resetState = () => {
    setImageData(null);
    setIsCameraOpen(true);
  };

  const handleCameraError = (error) => {
    console.error("Camera error:", error);
    if (error.name === "NotAllowedError") {
      setPermissionError(true);
    }
  };

  return (
    <div>
      {/* 📷 CAMERA */}
      {isCameraOpen && (
        <>
          {permissionError ? (
            <div>
              <p style={{ color: "red" }}>
                Camera access denied. Please allow camera permission.
              </p>
              <button onClick={() => window.location.reload()} className="btn btn-secondary">
                Retry
              </button>
            </div>
          ) : (
            <Camera
              onTakePhoto={handleTakePhoto}
              idealFacingMode="environment"
              isImageMirror={false}
              onCameraError={handleCameraError}
            />
          )}
        </>
      )}

      {/* ✂️ CROPPER */}
      {imageData && (
        <div>
          <div style={{ height: 400 }}>
            <Cropper
              ref={cropperRef}
              src={imageData}
              stencilComponent={RectangleStencil}
              stencilProps={{
                movable: true,
                resizable: true,
                lines: true,
                handlers: true,
              }}
              aspectRatio={undefined}     // 🔥 FREE CROP (like mobile)
              restrictions={false}        // 🔥 allow full freedom
            />

          </div>

          {/* ACTIONS */}
          <div style={{ textAlign: "center", marginTop: 10 }}>
            <button type="button" onClick={handleConfirmCrop} className="btn btn-secondary">
              Confirm
            </button>
            <button
              type="button"
              onClick={handleRetake}
              className="btn btn-secondary"
              style={{ marginLeft: 10 }}
            >
              Retake
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CameraWithCrop;
